module.exports = __webpack_public_path__ + "static/img/chixu@2x.a3e47fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/chixu@2x.png
// module id = L6VR
// module chunks = 1